// HelpLink.jsx — SB-151：页面通往手册对应章节的那枚 ❓，全站**一处定形**。
//
// 形状约束（helpLinks.test.mjs 按真调用形钉住）：
//  · to 恒为 `/help#<sectionId>`，sectionId 必须是 helpContent.mjs 里真实存在的章节
//    ——页与章的对应收在 HELP_PAGE_MAP 一张表上，页面各自传 section 时测试会对表核对。
//  · aria-label / tooltip 走 i18n（help.link），不写字面文案。
//  · 字形是文本 "?" 画在边框圈里（本项目不装 @mui/icons-material，同 AppShell 的 ≡）。
//  · **强读闸内不放**（SB-151 §2）：闸是路由无关的全局遮罩，导航之后闸依然盖在上面，
//    一枚永远点不出效果的按钮比没有更坏。
//
// newTab：密件正文窗口里那一枚专用。那个窗口是一次性密件正文在世上唯一的存身处，
// 站内导航会卸载它——点一下 ❓ 就把刚取出的正文丢了（库里那份已焚）。所以那一处用
// 普通 <a> 开新标签页（部署对任意路由都回 SPA，深链可用），其余场景一律站内跳转。
import { Box, IconButton, Tooltip } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { useT } from '../i18n/index.mjs';

export default function HelpLink({ section, newTab = false, sx }) {
  const t = useT();
  const label = t('help.link');
  const to = `/help#${section}`;
  const linkProps = newTab
    ? { component: 'a', href: to, target: '_blank', rel: 'noopener' }
    : { component: RouterLink, to };
  return (
    <Tooltip title={label}>
      <IconButton size="small" aria-label={label} sx={{ ml: 0.5, ...sx }} {...linkProps}>
        {/* 环形问号：靠边框画圈、颜色随 currentColor——页头与对话框两种底色都可辨。 */}
        <Box
          component="span"
          aria-hidden
          sx={{
            fontSize: 12,
            fontWeight: 700,
            lineHeight: 1,
            width: 18,
            height: 18,
            borderRadius: '50%',
            border: '1.5px solid currentColor',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          ?
        </Box>
      </IconButton>
    </Tooltip>
  );
}
